// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/es7.weak-set.of.js
// module id = 285
// module chunks = 0